(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.onTouchStartHandler = this.onTouchStart.bind(this);
      
      this.hideHeaderOnScrollUp = () => {
        this.preventReveal = true;
        clearTimeout(this.preventRevealTimer);
        this.preventRevealTimer = setTimeout(() => {
          this.preventReveal = false;
        }, 500);
      };

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      
      // scrollとtouchstartの両方でイベントを監視
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      window.addEventListener('touchstart', this.onTouchStartHandler, { passive: true });

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('touchstart', this.onTouchStartHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }
    
  onTouchStart() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      
      // トップ付近以外では、触れた瞬間に隠す
      if (scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      }
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop <= this.headerBounds.top) {
        // 最上部では常に表示
        requestAnimationFrame(this.reset.bind(this));
        window.clearTimeout(this.scrollStopTimer);
      } else {
        // スクロール中（移動中）は隠す
        requestAnimationFrame(this.hide.bind(this));
        
        window.clearTimeout(this.scrollStopTimer);
        
        // 止まってから300ms後に再表示（ここがフェードインのキモ）
        this.scrollStopTimer = setTimeout(() => {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
        }, 300); 
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
